import { Close } from "@mui/icons-material";
import { Autocomplete, Box, Button, FormControl, IconButton, TextField, Typography } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { TagsInputUniqueKeys } from "src/Components/Recon360/ReconMIS/AutoCompletes";
import { BusinessPartnerListForBcBeta } from "src/entity/recon-entity/ReconInterfaces";
import { BalanceConfirmationBetaStatuses } from "src/Utils/PartnerCommunication";
import { NdButton } from "../../MsmePartnerPortal/CommonComponents";
import $ from "../../MsmePartnerPortal/PartnerPortal.module.scss";
export interface BcNewFilterType {
  businessPartnerNames?: string[];
  vendorCodes?: string[];
  categories?: string[];
  taskLabels?: string[];
  statuses?: string[];
  dateOfClosingBalance?: string[];
}

export function DateFilter<T>(minDate: Date | string, maxDate: Date | string, rowsData: T[], key: keyof T) {
  if (minDate && maxDate) {
    rowsData = rowsData?.filter((item) => {
      if (item[key]) {
        return moment(item[key])?.format("YYYY-MM-DD") <= maxDate && moment(item[key])?.format("YYYY-MM-DD") >= minDate;
      }
      return false;
    });
  }
  if (minDate && !maxDate) {
    rowsData = rowsData?.filter((item) => {
      if (item[key]) {
        return moment(item[key])?.format("YYYY-MM-DD") >= minDate;
      }
      return false;
    });
  }
  if (!minDate && maxDate) {
    rowsData = rowsData?.filter((item) => {
      if (item[key]) {
        return moment(item[key])?.format("YYYY-MM-DD") <= maxDate;
      }
      return false;
    });
  }

  return rowsData;
}

type StateDispatch<T = any> = React.Dispatch<React.SetStateAction<T>>;

interface BalanceConfirmationFilterProps {
  allCategories: string[];
  allRowsData: BusinessPartnerListForBcBeta[];
  setRowsDataBalanceConfirmation: StateDispatch<BusinessPartnerListForBcBeta[]>;
  appliedFilters: BcNewFilterType;
  setAppliedFilters: StateDispatch<BcNewFilterType>;
  openFilter: boolean;
  setOpenFilter: StateDispatch<boolean>;
  newMailingConsumer?: boolean;
}

const BalanceConfirmationNewFilter = ({
  allCategories,
  allRowsData,
  setRowsDataBalanceConfirmation,
  openFilter,
  setOpenFilter,
  newMailingConsumer,
  appliedFilters,
  setAppliedFilters,
}: BalanceConfirmationFilterProps) => {
  const [categories, setCategories] = useState<string[]>(appliedFilters.categories ? appliedFilters.categories : []);
  const [statuses, setStatuses] = useState<string[]>(appliedFilters.statuses ? appliedFilters.statuses : []);
  const [fromDateOfClosingBalance, setFromDateOfClosingBalance] = useState<string>(
    appliedFilters.dateOfClosingBalance ? appliedFilters.dateOfClosingBalance[0] : null
  );
  const [toDateOfClosingBalance, setToDateOfClosingBalance] = useState<string>(
    appliedFilters.dateOfClosingBalance ? appliedFilters.dateOfClosingBalance[1] : null
  );
  const [partnerNames, setPartnerNames] = useState<string[]>(
    appliedFilters.businessPartnerNames ? appliedFilters.businessPartnerNames : []
  );
  const [vendorCodes, setVendorCodes] = useState<string[]>(
    appliedFilters.vendorCodes ? appliedFilters.vendorCodes : []
  );
  const [taskLabels, setTaskLabels] = useState<string[]>(appliedFilters.taskLabels ? appliedFilters.taskLabels : []);

  const handleApplyFilter = () => {
    const appliedFiltersObj = {};

    if (partnerNames?.length > 0) {
      appliedFiltersObj["businessPartnerNames"] = partnerNames;
    }

    if (vendorCodes?.length > 0) {
      appliedFiltersObj["vendorCodes"] = vendorCodes;
    }

    if (categories?.length > 0) {
      appliedFiltersObj["categories"] = categories;
    }
    if (statuses?.length > 0) {
      appliedFiltersObj["statuses"] = statuses;
    }

    if (taskLabels?.length > 0) {
      appliedFiltersObj["taskLabels"] = taskLabels;
    }

    if (fromDateOfClosingBalance || toDateOfClosingBalance) {
      appliedFiltersObj["dateOfClosingBalance"] = [fromDateOfClosingBalance, toDateOfClosingBalance];
    }
    setAppliedFilters(appliedFiltersObj);
    setOpenFilter(false);
  };

  const handleClearFilters = () => {
    setCategories([]);
    setStatuses([]);
    setTaskLabels([]);
    setPartnerNames([]);
    setVendorCodes([]);
    setFromDateOfClosingBalance(null);
    setToDateOfClosingBalance(null);
    setAppliedFilters({});
    setRowsDataBalanceConfirmation(allRowsData);
  };

  return (
    <Dialog open={openFilter} classes={{ paper: $.BR_fix }} maxWidth="sm" fullWidth keepMounted>
      <Box className="dialog_header space_between" alignItems="center" pr={1}>
        <DialogTitle component={"div"} width={"90%"}>
          Apply Filter
        </DialogTitle>
        <IconButton
          onClick={() => {
            setOpenFilter(false);
          }}
        >
          <Close />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          display: "flex",
          flexFlow: "column",
          gap: 1,
          px: 3,
          py: 2,
          "& .MuiFormControl-root, & .MuiInputBase-root.MuiOutlinedInput-root": {
            borderRadius: "4px",
          },
        }}
      >
        <div className="vertical_center_align ">
          <Typography variant="subtitle2">Partner Names </Typography>
          <FormControl sx={{ width: 360, ml: "auto" }}>
            <TagsInputUniqueKeys
              tags={partnerNames}
              setTags={setPartnerNames}
              className="partnerNamesAutocomplete"
              fullWidth={true}
              label=""
              placeholder="Newline separated Names"
              splitter="newline"
              limitTags={3}
              textFieldProps={{ multiline: true, maxRows: 4 }}
              options={allRowsData.map((row) => {
                return { businessPartnerName: row.businessPartnerName };
              })}
              accessor={"businessPartnerName"}
              uniqueKeyAccessor={"businessPartnerName"}
            />
          </FormControl>
        </div>
        <div className="vertical_center_align ">
          <Typography variant="subtitle2">Vendor Codes </Typography>
          <FormControl sx={{ width: 360, ml: "auto" }}>
            <TagsInputUniqueKeys
              tags={vendorCodes}
              setTags={setVendorCodes}
              className="partnerNamesAutocomplete"
              fullWidth={true}
              label=""
              placeholder="Newline separated Codes"
              splitter="newline"
              limitTags={3}
              textFieldProps={{ multiline: true, maxRows: 4 }}
              options={allRowsData
                .filter((row) => !(row.vendorCode === null || row.vendorCode === ""))
                .map((row) => {
                  return { vendorCode: row.vendorCode };
                })}
              accessor={"vendorCode"}
              uniqueKeyAccessor={"vendorCode"}
            />
          </FormControl>
        </div>
        <div className="vertical_center_align ">
          <Typography variant="subtitle2">Category </Typography>
          <FormControl sx={{ width: 360, ml: "auto" }}>
            <Autocomplete
              value={categories}
              fullWidth={true}
              onChange={(_, value) => {
                setCategories(value);
              }}
              size="small"
              multiple={true}
              id="tags-outlined"
              options={allCategories || []}
              getOptionLabel={(option) => option}
              filterSelectedOptions={true}
              renderInput={(params) => <TextField {...params} label="Select category" />}
            />
          </FormControl>
        </div>
        {!newMailingConsumer && (
          <div className="vertical_center_align ">
            <Typography variant="subtitle2">Label </Typography>
            <FormControl sx={{ width: 360, ml: "auto" }}>
              <Autocomplete
                value={taskLabels}
                fullWidth={true}
                onChange={(_, value) => {
                  setTaskLabels(value);
                }}
                size="small"
                multiple={true}
                id="tags-outlined"
                options={[
                  ...new Set(
                    allRowsData.filter((item) => !(item.label === null || item.label === "")).map((item) => item.label)
                  ),
                ]}
                getOptionLabel={(option) => option}
                filterSelectedOptions={true}
                renderInput={(params) => <TextField {...params} label="Select Label" />}
              />
            </FormControl>
          </div>
        )}
        <div className="vertical_center_align ">
          <Typography variant="subtitle2">Status </Typography>
          <FormControl sx={{ width: 360, ml: "auto" }}>
            <Autocomplete
              value={statuses}
              fullWidth={true}
              onChange={(_, value) => {
                setStatuses(value);
              }}
              size="small"
              multiple={true}
              id="tags-outlined"
              options={Array.from(new Set(Object.values(BalanceConfirmationBetaStatuses))) || []}
              getOptionLabel={(option) => option}
              filterSelectedOptions={true}
              renderInput={(params) => <TextField {...params} label="Select status" />}
            />
          </FormControl>
        </div>

        <div className="vertical_center_align ">
          <Typography variant="subtitle2">Date of closing balance </Typography>
          <FormControl sx={{ width: 360, ml: "auto", flexFlow: "row", justifyContent: "space-between" }}>
            <TextField
              label="From"
              InputLabelProps={{ shrink: true }}
              id="outlined-size-small"
              size="small"
              type="date"
              value={fromDateOfClosingBalance || ""}
              onChange={(e) => {
                setFromDateOfClosingBalance(e.target.value);
              }}
            />
            <TextField
              label="To"
              InputLabelProps={{ shrink: true }}
              id="outlined-size-small"
              size="small"
              type="date"
              value={toDateOfClosingBalance || ""}
              onChange={(e) => {
                setToDateOfClosingBalance(e.target.value);
              }}
            />
          </FormControl>
        </div>
        <div className="vertical_center_align "></div>
      </DialogContent>
      <DialogActions className="dialog_footer">
        <Button color="inherit" onClick={handleClearFilters}>
          Clear All
        </Button>
        <NdButton variant="contained" id="filterBalanceConfirmation_button" onClick={handleApplyFilter}>
          Apply
        </NdButton>
      </DialogActions>
    </Dialog>
  );
};

export default BalanceConfirmationNewFilter;
